<template>
  <div v-if="isOpen" class="t-datepicker-range-modal">
    <div class="t-datepicker-range-modal-content">
      <DatePickerRange
        :locale="localeFixed"
        :filter="filter"
        :range="range"
        @apply="handleApply"
        @cancel="handleCancel"
        @click-out="handleClickOut"
      />
    </div>

    <div class="t-datepicker-range-modal-overflow" />
  </div>
</template>

<script>
import DatePickerRange from './DatePickerRange.vue';

export default {
  name: 't-datepicker-range-modal',
  components: {
    DatePickerRange,
  },
  props: {
    filter: { type: String },
    isOpen: { type: Boolean, default: false },
    range: { type: Object, required: true },
    locale: {
      type: String,
      default: 'pt-BR',
      validator: (value) => ['en-US', 'es-ES', 'pt-BR', 'en_US', 'es_ES', 'pt_BR'].includes(value),
    },
  },
  computed: {
    localeFixed() {
      return this.locale.replace('_', '-');
    },
  },
  emit: ['apply', 'cancel', 'click-out', 'input'],
  methods: {
    handleApply(payload) {
      this.$emit('input', payload);
      this.$emit('apply', payload);
    },
    handleCancel(payload) {
      this.$emit('cancel', payload);
    },
    handleClickOut() {
      this.$emit('click-out');
    },
  },
};
</script>

<style lang="scss">
.t-datepicker-range-modal {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 999999;
}

.t-datepicker-range-modal-content {
  position: relative;
  z-index: 100;
}

.t-datepicker-range-modal-overflow {
  background-color: var(--track-color-bluegray-100);
  height: 100%;
  left: 0;
  opacity: 0.6;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 50;
}
</style>
